import { Grid } from '@forgeglobal/design-framework';
import { Persona } from '@tcs/client-portal-api/types/Persona';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import DateOfBirthTextField from '@tcs/common/components/atoms/DateOfBirthTextField';
import DropdownField from '@tcs/common/components/atoms/DropdownField';
import { Field } from '@tcs/common/components/atoms/Form';
import SsnTextField from '@tcs/common/components/atoms/SsnTextField';
import TextField from '@tcs/common/components/atoms/TextField';

interface IndividualBeneficiaryFormProps {
  form: any;
  isPrimary: boolean;
}

export const IndividualBeneficiaryForm = ({
  form,
  isPrimary,
}: IndividualBeneficiaryFormProps) => {
  const {
    claims: { clientPortalPersona: persona },
  } = useSession();

  const options = [
    {
      label: 'Spouse (Under Federal law)',
      value: 'Spouse',
    },
    {
      label: 'Non-Spouse Individual (Children, Relatives, Other)',
      value: 'Non-Spouse Individual',
    },
    {
      label: 'Notarized Spouse',
      value: 'Notarized Spouse',
    },
    {
      label: 'Notarized Non-Spouse',
      value: 'Notarized Non-Spouse',
    },
  ];
  const validateRelationship = (value: string) => {
    const validValues = options.map((option) => option.value);
    if (!validValues.includes(value)) {
      return 'Please select a valid relationship.';
    }
    return undefined;
  };

  if (
    form.getState().values.firstName &&
    !form.getState().values.relationship
  ) {
    form.blur('relationship'); // Mark the field as touched
  }

  const getRelationshipOptions = () => {
    if (persona !== Persona.Admin || !isPrimary) {
      return options.filter(
        (option) => option.value.startsWith('Notarized') === false,
      );
    }

    return options;
  };

  return (
    <>
      <Grid item data-test-id="beneficiary-form-relationship">
        <Field
          name="relationship"
          required
          validate={validateRelationship}
          render={(props) => {
            const isNotaryBeneficiary =
              props.input.value.startsWith('Notarized');
            return (
              <DropdownField
                label="Relationship"
                required
                disabled={isNotaryBeneficiary && persona !== Persona.Admin}
                {...props}
                options={getRelationshipOptions()}
              />
            );
          }}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-first-name">
        <Field
          name="firstName"
          required
          render={(props) => (
            <TextField data-private label="First name" {...props} normalize />
          )}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-middle-name">
        <Field
          name="middleName"
          render={(props) => (
            <TextField data-private label="Middle name" {...props} normalize />
          )}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-last-name">
        <Field
          name="lastName"
          required
          render={(props) => (
            <TextField data-private label="Last name" {...props} normalize />
          )}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-dob">
        <Field
          name="dateOfBirth"
          render={(props) => (
            <DateOfBirthTextField
              data-private
              label="Date of birth"
              {...props}
            />
          )}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-ssn">
        <Field
          name="socialSecurityNumber"
          render={(props) => (
            <SsnTextField
              data-private="lipsum"
              label="Social Security Number"
              {...props}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default IndividualBeneficiaryForm;
